import { actionTypes } from './action-types';

export const loadingActions = {
  setLoading: (payload: boolean) => ({
    type: actionTypes.SET_LOADING,
    payload,
  }),
};

type Actions = typeof loadingActions;
export type LoadingActions = ReturnType<Actions[keyof Actions]>;
